export default "__VITE_ASSET__47b83f0c__"